import React from 'react';

export const Video = ({onLoad, src, mimeType, autoplay=false, ...props}) =>
    <video className="polyphony-video" playsInline autoPlay={autoplay} loop muted onLoad={onLoad}
           {...props}><source src={src} type={mimeType} disableremoteplayback='true'/></video>;
Video.displayName = "Video";

export default Video;

